// Import the functions you need from the SDKs you need
import userService from './services/account/userService';
import { initializeApp } from 'firebase/app';
import {
    getAuth,
    signInWithPopup,
    GoogleAuthProvider,
    FacebookAuthProvider,
    sendPasswordResetEmail,
    signOut,
    getAdditionalUserInfo,
} from 'firebase/auth';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';

// import { getAnalytics } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE,
    authDomain: process.env.VUE_APP_AUTHDOMAIND,
    projectId: process.env.VUE_APP_PROJECTID,
    storageBucket: process.env.VUE_APP_STORAGEBUCKET,
    messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
    appId: process.env.VUE_APP_APPID,
    // measurementId: process.env.VUE_APP_MEASUREMENTID,
};

// Initialize Firebase
// const analytics = getAnalytics(app);
export const app = initializeApp(firebaseConfig);

let messaging = null;

/**
 * Shows a native browser notification when a push message arrives
 * and the app tab is in the foreground.
 * @param {object} payload - The FCM message payload.
 */
function showForegroundNotification(payload) {
    const { title, body } = payload.notification || {};
    const notificationLink = payload.data?.notificationLink || payload.data?.link || '/';

    if (!title || Notification.permission !== 'granted') return;

    const notification = new Notification(title, {
        body: body || '',
        icon: '/img/icons/android-chrome-192x192.png',
        badge: '/img/icons/android-chrome-192x192.png',
        tag: payload.data?.triggerId || 'lixsa-notification',
    });

    notification.onclick = () => {
        window.focus();
        if (notificationLink && notificationLink !== '/') {
            window.location.href = notificationLink;
        }
        notification.close();
    };
}

/** @type {Promise<void>} Resolves when messaging is initialized (or skipped if unsupported). */
const messagingReady = (async () => {
    if (await isSupported()) {
        messaging = getMessaging(app);
        onMessage(messaging, (payload) => {
            console.log('Message received. ', payload);
            showForegroundNotification(payload);
        });
    } else {
        console.warn('Firebase Messaging is not supported in this browser.');
    }
})();

/**
 * Generates a new FCM token and registers it with the backend.
 * @param {string} userId - The user ID to associate the token with.
 * @returns {Promise<string|null>} The FCM token, or null if unsupported.
 */
async function generateToken(userId) {
    if (!messaging) {
        console.warn('Push messaging is not supported in this browser.');
        return null;
    }
    try {
        const token = await getToken(messaging, {
            vapidKey: process.env.VUE_APP_FIREBASE_VAPID,
        });
        if (token) {
            await userService.addPushNotificationToken(userId, token);
        }
        return token;
    } catch (error) {
        console.error('Error getting FCM token:', error);
        throw error;
    }
}

export default {
    /**
     * Requests browser notification permission and registers the FCM token.
     * Safe to call multiple times — idempotent. Token deduplication is
     * handled server-side. The browser prompt only appears the first time.
     */
    async requestPermission() {
        try {
            // Wait for messaging to be initialized (fixes race condition)
            await messagingReady;
            if (!messaging) {
                console.warn('Push messaging is not supported in this browser.');
                return;
            }
            const userId = localStorage.getItem('userId');
            if (!userId) return;

            const permission = await Notification.requestPermission();
            if (permission !== 'granted') return;

            // Always generate and register the token with the backend.
            // Server-side deduplication prevents duplicates.
            // Re-registering ensures the token stays fresh after rotations.
            await generateToken(userId);
        } catch (error) {
            console.error('Error getting FCM token:', error);
        }
    },

    async signInWithGoogle() {
        try {
            const provider = new GoogleAuthProvider();
            const auth = getAuth();
            const res = await signInWithPopup(auth, provider);
            const { isNewUser } = getAdditionalUserInfo(res);
            return { ...res, isNewUser };
        } catch (error) {
            throw error;
        }
    },

    async signInWithFacebook() {
        try {
            const provider = new FacebookAuthProvider();
            const auth = getAuth();
            const res = await signInWithPopup(auth, provider);
            const { isNewUser } = getAdditionalUserInfo(res);
            return { ...res, isNewUser };
        } catch (error) {
            throw error;
        }
    },

    async SignOut() {
        try {
            const auth = getAuth();
            return await signOut(auth);
        } catch (error) {
            console.error('Error en el servicio de firebae: ', error);
            throw error;
        }
    },

    async sendPasswordResetEmail(email) {
        try {
            const auth = getAuth();
            return await sendPasswordResetEmail(auth, email);
        } catch (error) {
            throw error;
        }
    },

    messaging,
};
